import { makeAutoObservable } from 'mobx';
import type { DialogMessageDto, DialogMode } from '../types/chat';
import { v4 } from 'uuid';
import { sseService } from '../api/services/sseService';

export class SseStore {
  connectionId: string = v4();
  isConnected: boolean = false;
  eventSource: EventSource | null = null;

  dialogMessageEvent: DialogMessageSseEvent | null = null;
  setDialogMessageEvent = (v: DialogMessageSseEvent | null) => (this.dialogMessageEvent = v);

  dialogModeChangeEvent: DialogModeChangeSseEvent | null = null;
  setDialogModeChangeEvent = (v: DialogModeChangeSseEvent | null) =>
    (this.dialogModeChangeEvent = v);

  operatorRequestedEvent: OperatorRequestedSseEvent | null = null;
  setOperatorRequestedEvent = (v: OperatorRequestedSseEvent | null) =>
    (this.operatorRequestedEvent = v);

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  close = () => {
    this.eventSource?.close();
    this.eventSource = null;
    this.isConnected = false;
  };

  init = () => {
    this.eventSource = sseService.setSseConnection(this.connectionId);

    this.eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      // console.log('New SSE event:', data);
      this.setSseEvent(data);
    };

    this.eventSource.onerror = (err) => {
      console.error('SSE error:', err);
      // es.close();
    };
  };

  setSseEvent = (e: SseEvent) => {
    switch (e.type) {
      case SseEventType.Connected:
        this.isConnected = true;
        break;

      case SseEventType.DialogMessage:
        this.setDialogMessageEvent(e);
        break;

      case SseEventType.DialogModeChange:
        this.setDialogModeChangeEvent(e);
        break;

      case SseEventType.OperatorRequested:
        this.setOperatorRequestedEvent(e);
        break;

      default:
        console.error('SSE-событие неизвестного типа');
    }
  };
}

export type SseEvent =
  | DialogMessageSseEvent
  | DialogModeChangeSseEvent
  | ConnectedSseEvent
  | OperatorRequestedSseEvent;

type DialogMessageSseEvent = {
  type: SseEventType.DialogMessage;
  dialog_message: DialogMessageDto;
  dialog_mode: DialogMode;
  expert_name: string;
  expert_image_id: string;
};

type DialogModeChangeSseEvent = {
  type: SseEventType.DialogModeChange;
  dialog_id: string;
  user_id: string;
  mode: DialogMode;
};

type ConnectedSseEvent = {
  type: SseEventType.Connected;
};

export type OperatorRequestedSseEvent = {
  type: SseEventType.OperatorRequested;
  dialog_id: string;
  user_id: string;
  expert_name: string;
  expert_image_id: string;
};

enum SseEventType {
  Connected = 'connected',
  DialogMessage = 'dialog_message',
  DialogModeChange = 'dialog_mode_change',
  OperatorRequested = 'operator_requested',
}

export const sseStore = new SseStore();
